//@ts-check
import createCachedSelector from 're-reselect';
import { getDataType } from '../../data';

var optionsSelector = function optionsSelector(state, options) {
  return options;
};

export var gridDataSelector = function gridDataSelector(state, _ref) {
  var dataType = _ref.dataType;
  var config = getDataType(dataType);
  if (!config) return {};
  return state.grid.data[config.data.dataKey] || {};
};

var getDataState = function getDataState(_ref2, data) {
  var id = _ref2.id;
  return data[id];
};
/**
 * @type {(state: any, item: import('data/types').DataItemIdentifier) => any}
 */


var selector = createCachedSelector(optionsSelector, gridDataSelector, getDataState)(function (state, _ref3) {
  var dataType = _ref3.dataType,
      id = _ref3.id;
  return dataType + id;
});
export default selector;